__turbopack_context__.v({
  "buttonContainer": "cRTklq_buttonContainer",
  "container": "cRTklq_container",
  "desktopList": "cRTklq_desktopList",
  "header": "cRTklq_header",
  "mobileList": "cRTklq_mobileList",
  "noTaxUnitsLink": "cRTklq_noTaxUnitsLink",
  "noTaxUnitsText": "cRTklq_noTaxUnitsText",
});
